import React, { useState } from "react";

const FreeTextListSection = ({
  isEditing,
  label,
  items = [],
  onChange,
  placeholder = "Add details here",
}) => {
  const [inputValue, setInputValue] = useState("");

  const handleAdd = () => {
    if (!isEditing) return;
    const value = inputValue.trim();
    if (!value) return;
    onChange([...(items || []), { id: Date.now(), text: value }]);
    setInputValue("");
  };

  const handleRemove = (id) => {
    if (!isEditing) return;
    const next = (items || []).filter((i) => i.id !== id);
    onChange(next);
  };

  return (
    <div className="bg-white p-6 border border-[#E6E6E6]">
      <h2 className="text-[11px] font-bold text-[#3C3C3C] mb-3">{label}</h2>

      <div className="mb-4">
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder={placeholder}
          disabled={!isEditing}
          className="w-full h-12 px-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-[#1A212F] text-[16px] placeholder:text-[#1A212F66] disabled:bg-gray-50 disabled:text-gray-500"
        />
      </div>

      {isEditing && (
        <button
          onClick={handleAdd}
          className="px-4 py-2 border border-[#E6E6E6] bg-white text-[#1E1E1E] rounded-lg"
        >
          Add new row
        </button>
      )}

      <div className="mt-4 space-y-2">
        {(items || []).map((item) => (
          <div key={item.id} className="flex items-center justify-between border border-[#D6DBEA] rounded-lg bg-[#F8F9FB] px-3 py-2">
            <span className="text-[#1A212F] text-[14px]">{item.text}</span>
            {isEditing && (
              <button onClick={() => handleRemove(item.id)} className="w-6 h-6 rounded-full bg-[#FF4D4F1A] border border-[#FF4D4F] flex items-center justify-center">
                <span className="text-[#FF4D4F] text-xs font-bold">×</span>
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FreeTextListSection;

